import { connect } from 'react-redux';

import Helper from './Helper';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  config: state.config,
});


export default connect(mapStateToProps)(Helper);
